import { useSelector } from 'react-redux';

import { Pages, selectStreamOnPromo } from '@app/redux/streamOnPromo';

import { ErrorPage } from './error';
import { OrderReview } from './orderReview';
import { OrderSummary } from './orderSummary';
import { UnavailablePage } from './unavailable';

export const StreamOnNavigator = () => {
  const {
    streamEligibility: { isEligible },
    currentPage,

    didOrderSucceed,
  } = useSelector(selectStreamOnPromo);

  if (!isEligible && !didOrderSucceed) {
    return <UnavailablePage />;
  }

  switch (currentPage) {
    case Pages.orderReview:
      return <OrderReview />;
    case Pages.orderSummary:
      return <OrderSummary />;
    case Pages.error:
      return <ErrorPage />;
    case Pages.unavailable:
      return <UnavailablePage />;
    case Pages.None:
    default:
      return null;
  }
};

export default StreamOnNavigator;
